import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { groupTrussDesignDrawingTemplates, TrussDesignDrawingTemplates } from '@paragon/client-tools';
import { AnnotationTemplateWithoutContents } from '@paragon/contract-library';

export type AnnotationTemplatesState = TrussDesignDrawingTemplates;

const initialState: AnnotationTemplatesState = {
  trussDesignDrawingTemplates: null,
  trussDesignDrawingOverflowTemplates: null,
  repairTrussDesignDrawingTemplates: null,
};

const annotationTemplatesSlice = createSlice({
  name: 'annotationTemplates',
  initialState,
  reducers: {
    annotationTemplatesLoaded: (_, action: PayloadAction<readonly AnnotationTemplateWithoutContents[]>) =>
      castDraft(groupTrussDesignDrawingTemplates(action.payload)),
  },
});

export const { annotationTemplatesLoaded } = annotationTemplatesSlice.actions;
export const annotationTemplates = annotationTemplatesSlice.reducer;
